import { render, staticRenderFns } from "./vue-file-agent.vue?vue&type=template&id=1410c648&"
import script from "./vue-file-agent.vue?vue&type=script&lang=ts&"
export * from "./vue-file-agent.vue?vue&type=script&lang=ts&"
import style0 from "./vue-file-agent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports